import { render, staticRenderFns } from "./CommandGroup.vue?vue&type=template&id=3da77ba2"
import script from "./CommandGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommandGroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports